module.exports = __webpack_public_path__ + "static/media/less_than_equal_to.c3bd09c7.svg";